<template>
  <div class="form-group row">
    <div class="col-12 row justify-content-md-center">
      <hr class="col-10">
    </div>

    <div class="col-12 h5"> Remetente </div>
    <div class="col-sm-2 text-sm-right">
      <label>Sigla Órgão:</label>
    </div>
    <div class="col-md-2 col-sm-10 mb-3">
      <input type="text" class="form-control" v-model="filtro['atributos.siglaOrgao']">
    </div>
    <div class="col-sm-2 text-sm-right">
      <label>Órgão:</label>
    </div>
    <div class="col-md-6 col-sm-10 mb-3">
      <input type="text" class="form-control" v-model="filtro['atributos.descricaoOrgao']">
    </div>
    <div class="col-sm-2 text-sm-right">
      <label>Sigla Departamento:</label>
    </div>
    <div class="col-md-2 col-sm-10 mb-3">
      <input type="text" class="form-control" v-model="filtro['atributos.siglaDepartamento']">
    </div>
    <div class="col-sm-2 text-sm-right">
      <label>Departamento:</label>
    </div>
    <div class="col-md-6 col-sm-10 mb-3">
      <input type="text" class="form-control" v-model="filtro['atributos.descricaoDepartamento']">
    </div>

    <div class="col-12 row justify-content-md-center">
      <hr class="col-10">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    progressName: { required: true, type: String }
  },

  computed: mapState({
    filtro: state => state.filtroGeral,
    progress: state => state.progressFiltroGeral,
    progressEstrutura () {
      var count = 0
      var max = 4
      count += this.filtro['atributos.descricaoOrgao'] && this.filtro['atributos.descricaoOrgao'] !== '' ? 1 : 0
      count += this.filtro['atributos.siglaOrgao'] && this.filtro['atributos.siglaOrgao'] !== '' ? 1 : 0
      count += this.filtro['atributos.descricaoDepartamento'] && this.filtro['atributos.descricaoDepartamento'] !== '' ? 1 : 0
      count += this.filtro['atributos.siglaDepartamento'] && this.filtro['atributos.siglaDepartamento'] !== '' ? 1 : 0

      return (count / max) * 100
    }
  }),

  watch: {
    progressEstrutura (newValue) {
      this.progress[this.progressName] = newValue.toFixed()
      this.progress.change = !this.progress.change
    }
  }
}
</script>
